module.exports = __webpack_public_path__ + "static/media/insured-car.7e327ebb.png";